import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';

import { Environment } from 'src/environments/environment.model';

import { ManualCrop } from '../../shared/models';

@Injectable({
  providedIn: 'root',
})
export class CropFieldService {
  private readonly http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = this.env.APIM_BASE_URL + '/arable-advice-service/crop-fields';

  upsertAutomaticAdviceCropFields(cropField: ManualCrop) {
    return this.http.post(`${this.baseUrl}/automatic-advice`, cropField);
  }

  deleteCropField(cropFieldId: number) {
    return this.http.delete(`${this.baseUrl}/${cropFieldId}`);
  }
}
